  <template>
<div>
  <v-toolbar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    dense
    app
    fixed
    flat
    style="background-color: #F5F7FD;"
  > 
   <v-toolbar-side-icon
      small
      title="Menu"
      v-if="$mq==='mobile'"
      v-model="topMenuDrawer"
      class="toolbarBtnColor"
      v-on:click="TriggerDrawEvent"
    ></v-toolbar-side-icon>
   
    <img :style="$mq!='mobile' ? 'margin-right:50px' : ''" src="/images/xtend.svg" width= "95.55px" height= "26px "/>
   
    <!-- <v-text-field    
      style="border:0px;padding:10px"
      v-model="search"
      hide-details
      prepend-inner-icon="search"
      solo
      placeholder="Search..."
      class="searchText white black--text"
      height="24px"
    /> -->
    &nbsp;
    &nbsp;
    <v-spacer />
    <div class="topMenuIcon ma-1">
   
    <svg @click="$router.push('/')" width="19" height="22" viewBox="0 0 58.365 58.365" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M57.863,26.632l-8.681-8.061V5.365h-10v3.921L29.182,0L0.502,26.632c-0.404,0.376-0.428,1.009-0.052,1.414
	c0.375,0.404,1.008,0.427,1.414,0.052l3.319-3.082v33.349h16h16h16V25.015l3.319,3.082c0.192,0.179,0.437,0.267,0.681,0.267
	c0.269,0,0.536-0.107,0.732-0.319C58.291,27.641,58.267,27.008,57.863,26.632z M41.182,7.365h6v9.349l-6-5.571V7.365z
	 M23.182,56.365V35.302c0-0.517,0.42-0.937,0.937-0.937h10.126c0.517,0,0.937,0.42,0.937,0.937v21.063H23.182z M51.182,56.365h-14
	V35.302c0-1.62-1.317-2.937-2.937-2.937H24.119c-1.62,0-2.937,1.317-2.937,2.937v21.063h-14V23.158l22-20.429l14.28,13.26
	l5.72,5.311v0l2,1.857V56.365z" fill="#ADADAD"  stroke-width="2"  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>
 <CogsMenu v-if="isLoggedUser && user.data.User.user_type=='A'" />
    <div class="topMenuIcon ma-1" v-if="user.user_type=='A'">
        <svg class="ma-1" @click="$router.push('/reports')" width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>Report</title>
        <path d="M12.2884 17.9581H2.67085C1.74577 17.9581 1 17.1877 1 16.2414V2.71675C1 1.76626 1.74984 1 2.67085 1H12.2843C13.2094 1 13.9552 1.77044 13.9552 2.71675V16.2372C13.9592 17.1877 13.2094 17.9581 12.2884 17.9581Z"  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.35547 7.01953H11.5874"  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.37573 9.99219H11.6077"  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.37573 12.9648H11.6077"  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="topMenuIcon ma-1">
        <svg  @click="$router.push('/reportSubscriptions')" width="22" height="16" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <title>Report Subscription</title>
          <path d="M4 19V12"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 8V1"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 19V10"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 6V1"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 19V14"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 10V1"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1 12H7"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 6H15"  stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 14H23"  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </div>
     
    <div class="dark-toolbarBtnColor text-xs-left pt-1 pr-3" style="float:right">
          <img style="cursor:pointer" :src="notificationsData.length>0 ? '/images/notification.svg' : '/images/notification2.svg'" 
           @click="showNotificationList"
         />
     </div>
       &nbsp; &nbsp;  
    <AddMenu v-if="isLoggedUser " />
     &nbsp; &nbsp;  
    <UserMenu v-if="isLoggedUser " />
  </v-toolbar>
  </div>
</template>
<script>
import CompanySelection from "./CompanySelection.vue";
import BreadCrumps from "./BreadCrumps.vue";
import DigitalClock from "./DigitalClock.vue";
import UserMenu from "./UserMenu.vue";
import AddMenu from "./AddMenu.vue";
import CogsMenu from './CogsMenu.vue'
import lodash from 'lodash'
import Notification from './Notification.vue'
import DashboardModel from '../api/service/DashboardService.js'
import NotificationModel from "@/api/service/NotificationService";
import Multiselect from "vue-multiselect";
import DocumentModel from "@/api/service/DocumentService.js";
import { RotateSquare2 } from "vue-loading-spinner";
import { Socket } from "vue-loading-spinner";
import { Circle2 } from "vue-loading-spinner";
export default {
  components: {
    BreadCrumps,
    DigitalClock,
    CompanySelection,
    UserMenu,
    AddMenu,
    CogsMenu,
    RotateSquare2,
    Socket,
    Circle2,
    Multiselect,
  },
  props: ["topMenuDrawer", "roleId"],

  data() {
    return {
      search:"",
      isLoggedUser: false,
      searchdat: false,
      image: require("@/assets/team-icon.svg"),
      notificationsData: [],
      lookup: [],
      lookups: [],
      value: [],
      isLoading: false,
      userImage: "",
      defImage: require("@/assets/team-icon.svg")
    };
  },
   watch: {
    value(value) {
      if (value.type == "Product") {
         window.location.replace('/productView?id='+ value.key_id)
      } else if (value.type == "Sale") {
         window.location.replace('/pos?id='+ value.key_id)
      } else if(value.type=='Purchase'){
        window.location.replace('/poView?id='+ value.key_id)
      }else if(value.type=='Inventory'){
        window.location.replace('/inventoryView?id='+ value.key_id)
      } else if(value.type=='Grn'){
        window.location.replace('/grnView?id='+ value.key_id)
      }
    }
  },
  created: function() {
    this.user = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE));
    this.isLoggedUser = this.user ? true : false;
    // this.getNotifications()
    this.getLookups()
  },
  methods: {
    getNotifications() {
      var userId = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User
        .id;
      NotificationModel.findAll({ user_id: userId, accepted: 0 })
        .then(response => {
          this.setNotification(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    customLabel({ label }) {
      return ` ${label}`;
      //return  `${order_ref_id} - ${first_name} ${last_name}`
    },
    setNotification($notifications) {
      this.notifications = $notifications;
    },
    processLogClick() {
      //this.$parent.$emit('processClicked')
      this.$parent.$emit("processClicked", true);
    },
    TriggerDrawEvent() {
      this.$parent.$emit("drawerClicked");
    },
    showNotificationList() {
      this.$parent.$emit("NotificationListClicked");
    },
    async getLookups() {
    },
    searchdata() {
      this.searchdat = true;
    },
    searchdataf() {
      this.searchdat = false;
    },
    showChatBox() {
      this.$parent.$emit("chatDrawerClicked");
    }
  }

};
</script>
<style>
.tool-bar {
 background: #F5F7FD;
  border-bottom: 2px solid #263a4a;
}
.ttitle {
  font-family: "Times New Roman";
  font-size: 24px !important;
  font-weight: bolder;
}
.ttitle1 {
  font-size: 14px !important;
  font-weight: bolder;
}
.tool-bar .v-btn {
  min-width: 0;
  margin: 0px;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot:before {
 background-image:url("/images/search.png")
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
    height:24px !important;
    padding:0px;
    margin:0px;
}

.searchText .theme--light.v-text-field--outline:not(.v-input--is-focused) > .v-input__control > .v-input__slot {
  border: 0px solid rgb(201, 198, 198);
  font-size:14px
}
.searchText .theme--light.v-text-field--outline>.v-input--is-focused > .v-input__control > .v-input__slot:focus {
  border: 0px solid orange;
  font-size:14px
}
.searchText .theme--light.v-text-field--outline.v-input--is-focused > .v-input__control > .v-input__slot:hover {
  border: 0px solid rgba(79, 150, 207, 0.87) !important;
  border-radius:4px;
}
.searchText .theme--light.v-text-field--outline.v-input--is-focused > .v-input__control > .v-input__slot:hover {
  border: 0px solid rgba(79, 150, 207, 0.87) !important;
  border-radius:4px;
}
.bgTeal {

}
.bgFormat {
  background-color:teal;
    position:fixed;
    height:15%;

}
svg {
  stroke:#BDBDBD;
  cursor:pointer;
  
}
.topMenuIcon {
  margin-top:15%;
  margin-bottom:15%;
  padding:5px;
}
.topMenuIcon:hover svg {
  stroke:white !important;
  background: #5F45FF;
}
.topMenuIcon:hover  {
   background-color:#5F45FF;
    border-radius:10px;
}
.multiselect__tags {
  min-height: 34px !important;
  padding: 5px 40px 0 5px !important;
}
.multiselect--active .multiselect__select:before {
  padding-top: 10px;
}
.multiselect__content {
  width: 100%;
}
.multiselect__option {
  padding: 6px !important;
  min-height: 25px !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>  